export default __webpack_public_path__ + "static/media/members-icon-pair.39c1d7da.svg";